import Button from "components/ui/Button";
import styled from "styled-components";

const MainWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: linear-gradient(-45deg, #4c5bcd, #4b7fcf, #4bc0d4);
  background-size: 400% 400%;
  animation: gradient 3s ease infinite;
  font-family: Pretendard;

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  .viewus_main_logo {
    position: absolute;
    /* width: 39%; */
    width: 747px;
    right: 0;
    bottom: 28px;
  }
`;

const TextContainer = styled.div`
  position: absolute;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-45%, -50%);

  @media screen and (max-width: 767px) {
    /* top: 30%;
    left: 50%; */
  }

  .main_title {
    color: #fff;
    font-size: 3.4rem;
    font-weight: 700;
    line-height: 64px; /* 128% */
    letter-spacing: -0.5px;
    margin-bottom: 16px;
    @media screen and (max-width: 767px) {
      font-size: 2.5rem;
    }
  }
  .sub_title {
    color: #f9f9f9;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 30px; /* 150% */
    letter-spacing: -0.2px;
    @media screen and (max-width: 767px) {
      font-size: 1.2rem;
    }
  }
`;

const ButtonWrap = styled.div`
  margin-top: 105px;
  display: flex;
  > a,
  button {
    border-radius: 8px;
    font-size: 1.2rem;
    border: 1px solid #fff;
  }

  .a__login {
    display: inline-flex;
    padding: 15px 30px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #fff;
    color: #000;
  }
  button {
    padding: 0 30px;
    margin-left: 10px;
  }
`;
function Main(): JSX.Element {
  return (
    <MainWrapper>
      <img className="viewus_main_logo" alt="ViewUs Logo" src="/images/viewus_main_logo.png" />
      <TextContainer>
        <div className="main_title">
          콘텐츠 프로바이더와 퍼블리셔를 위한
          <br />
          원스톱 콘텐츠 유통 솔루션
        </div>
        <div className="sub_title">
          450여개 콘텐츠사가 만들어내는 수백만 개의 콘텐츠를 통해
          <br />또 다른 수익모델을 경험하세요
        </div>

        <ButtonWrap>
          <a className="a__login" href="/login">
            로그인
          </a>
          <Button
            color="white"
            btnType="ghost"
            btnSize="lg"
            text="서비스 알아보기"
            onClick={() => window.open("https://fastview.viewus.co.kr/")}
          />
        </ButtonWrap>
      </TextContainer>
    </MainWrapper>
  );
}

export default Main;
